import { Pipe, PipeTransform } from '@angular/core';

export const NO_VALUE = '-';
export const DOUBLE_DASH = '--';

@Pipe({
  name: 'dash',
  standalone: true,
})
export class DashPipe implements PipeTransform {
  transform(value: string | number): any {
    if (typeof value === 'number') {
      if (isNaN(value)) {
        return NO_VALUE;
      }

      value = value.toString();
    }

    return value && value.trim() ? value : NO_VALUE;
  }
}
